import { connect } from 'react-redux';
import {
  branch,
  compose,
  lifecycle,
  renderNothing,
  withHandlers,
  withProps,
  withPropsOnChange,
} from 'recompose';

import { t } from '../../../../../modules/infra/i18n';
import ShowCard from '../components/showCard';
import {
  fetchShopPaymentCard,
  updateShopPaymentCard,
  fetchBarberPaymentCard,
  updateBarberPaymentCard,
} from '../../actions';
import { getBarbers } from '../../../barbers/actions';
import { getList } from '../../../barbers/selector';
import fetchOnUpdate from '../../../../common/decorators/fetchOnUpdate';
import { getRoleIdType, getIsCommissionShop, getActiveShop } from '../../../../auth/selectors';
import { getPaymentCard } from '../../selectors';
import withToggle from '../../../../common/hoc/withToggle';
import withNotifications from '../../../../common/withNotifications';
import withCurrency from '../../../../common/hoc/withCurrency';

const mapStateToProps = state => ({
  paymentCard: getPaymentCard(state),
  shopOrBarber: getRoleIdType(state),
  isCommissionShop: getIsCommissionShop(state),
  activeShop: getActiveShop(state),
  shopBarbers: getList(state),
});

const mapDispatchToProps = {
  fetchShopPaymentCard,
  updateShopPaymentCard,
  fetchBarberPaymentCard,
  updateBarberPaymentCard,
  getBarbers,
};

const fetch = fetchOnUpdate(['id'], (params, actions) => {
  actions.fetch(params.id);
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    props => props.activeShop.brand.shopCount > 1
             || (props.shopOrBarber.type === 'barber' && props.shopBarbers.length > 1),
    renderNothing
  ),
  withCurrency,
  withToggle('form'),
  withToggle('loading'),
  withNotifications,
  withHandlers({
    updateCard: props => (data) => {
      props.loadingOn();
      let updateAction = props.updateShopPaymentCard;
      if (props.shopOrBarber.type === 'barber') {
        updateAction = props.updateBarberPaymentCard;
      }
      return updateAction(props.shopOrBarber.id, data).then((response) => {
        props.formOff();
        props.loadingOff();
        props.addNotification({
          message: t('settings:payment_card.card_updated_successfully'),
          level: 'success',
          title: t('common:success_title'),
        });
        return response;
      }).catch((err) => {
        props.loadingOff();
        throw err;
      });
    },
    fetch: props => () => {
      let fetchAction = props.fetchShopPaymentCard;
      if (props.shopOrBarber.type === 'barber') {
        fetchAction = props.fetchBarberPaymentCard;
      }
      return fetchAction(props.shopOrBarber.id);
    },
  }),
  withProps(props => ({
    actions: {
      fetch: props.fetch,
      fetchShopBarbers: props.fetchShopBarbers,
    },
    params: {
      id: props.shopOrBarber.id,
      type: props.shopOrBarber.type,
    },
  })),
  withPropsOnChange(['shopOrBarber'], (props) => {
    if (props.shopOrBarber.type === 'barber' && !props.shopBarbers.length) {
      props.getBarbers(props.activeShop.id);
    }
  }),
  fetch,
  lifecycle({
    componentDidMount() {
      this.props.fetch();
    },
  })
);

export default enhance(ShowCard);
